/**
 * The court system timezones that our application supports.
 *
 * Adding a supported timezone will have two effects:
 *
 * - @ftr/web's webpack build script will include the timezone's data in the generated bundle (you will need
 *   to update to the latest @ftr/contracts version to trigger this).
 * - The timezone will be allowed to be used when creating a new court system
 *
 * When adding a new timezone check `@js-joda/timezone` and `moment-timezone`'s list of timezones to
 * ensure that there is compatibility between the two timezone libraries:
 *
 * - https://github.com/moment/moment-timezone/blob/develop/data/packed/latest.json
 * - https://github.com/js-joda/js-joda/blob/main/packages/timezone/data/packed/latest.json
 *
 * @type Timezone[]
 */
export const SUPPORTED_TIMEZONES = [
    // Massachusetts
    {
        momentTimezone: 'America/New_York',
        jodaTimezone: 'America/New_York',
    },
    // Alberta
    {
        momentTimezone: 'Canada/Mountain',
        jodaTimezone: 'Canada/Mountain',
    },
    // Los Angeles
    {
        momentTimezone: 'America/Los_Angeles',
        jodaTimezone: 'America/Los_Angeles',
    },
    // Denver (Identical to Canada/Mountain)
    {
        momentTimezone: 'America/Denver',
        jodaTimezone: 'America/Denver',
    },
    // Wisconsin (US Central)
    {
        momentTimezone: 'America/Chicago',
        jodaTimezone: 'America/Chicago',
    },
    // London
    {
        momentTimezone: 'Europe/London',
        jodaTimezone: 'Europe/London',
    },
    // British Columbia
    {
        momentTimezone: 'America/Vancouver',
        jodaTimezone: 'America/Vancouver',
    },
    // Arizona
    {
        momentTimezone: 'America/Phoenix',
        jodaTimezone: 'America/Phoenix',
    },
    // Brisbane (+10)
    {
        momentTimezone: 'Australia/Brisbane',
        jodaTimezone: 'Australia/Brisbane',
    },
    // Sydney (+11)
    {
        momentTimezone: 'Australia/Sydney',
        jodaTimezone: 'Australia/Sydney',
    },
    // Broken Hill in NSW (+9:30)
    {
        momentTimezone: 'Australia/Broken_Hill',
        jodaTimezone: 'Australia/Broken_Hill',
    },
    // Melbourne (+11)
    {
        momentTimezone: 'Australia/Melbourne',
        jodaTimezone: 'Australia/Melbourne',
    },
    // Adelaide (+9:30)
    {
        momentTimezone: 'Australia/Adelaide',
        jodaTimezone: 'Australia/Adelaide',
    },
    // Darwin (+9:30)
    {
        momentTimezone: 'Australia/Darwin',
        jodaTimezone: 'Australia/Darwin',
    },
    // Perth (+8)
    {
        momentTimezone: 'Australia/Perth',
        jodaTimezone: 'Australia/Perth',
    },
    // Perth (Eucla) (+8:45)
    {
        momentTimezone: 'Australia/Eucla',
        jodaTimezone: 'Australia/Eucla',
    },
    // Tasmania (+10)
    {
        momentTimezone: 'Australia/Hobart',
        jodaTimezone: 'Australia/Hobart',
    },
    // Auckland (+12)
    {
        momentTimezone: 'Pacific/Auckland',
        jodaTimezone: 'Pacific/Auckland',
    },
    // Johannesburg (+2)
    {
        momentTimezone: 'Africa/Johannesburg',
        jodaTimezone: 'Africa/Johannesburg',
    },
    // Seychelles (+4)
    {
        momentTimezone: 'Indian/Mahe',
        jodaTimezone: 'Indian/Mahe',
    },
    // Puerto Rico (-4)
    {
        momentTimezone: 'America/Puerto_Rico',
        jodaTimezone: 'America/Puerto_Rico',
    },
    // Namibia (+2)
    {
        momentTimezone: 'Africa/Windhoek',
        jodaTimezone: 'Africa/Windhoek',
    },
    // UTC offset identifier. Pending being able to configure a court system's timezone via the UI,
    // This is the hardcoded value that Web sends to the API in `CreateCourtSystemBody`.
    // We need to specify it here so that the `SupportedTimezone` validator doesn't barf when encountering it.
    // TODO This should really be the time zone "UTC", but pending FTRX-3097 ZoneId deserialization
    // Deserializes this to the offset "Z".
    {
        momentTimezone: 'Z',
        jodaTimezone: 'Z',
    },
];
